/**
 * Utility to help make a word plural. Provide a count and a word to make plural.
 *
 * Defaults to adding an 's' to the end of the word:
 * ```tsx
 * pluralize(1, 'dog'); // -> 'dog'
 * pluralize(2, 'dog'); // -> 'dogs'
 * ```
 *
 * Can optionally provide a second word if adding an 's' would not be correct:
 * ```tsx
 * pluralize(1, 'mouse', 'mice'); // -> 'mouse'
 * pluralize(2, 'mouse', 'mice'); // -> 'mice'
 * ```
 **/
export function pluralize(
  count: number,
  word: string,
  pluralWord?: string
): string {
  return count === 1 ? word : (pluralWord ?? word + 's');
}
